<router-outlet name="app-bar"></router-outlet>
<router-outlet name="header"></router-outlet>
<main>
  <ng-template #contentContainer></ng-template>
  <router-outlet></router-outlet>
</main>
<router-outlet name="footer"></router-outlet>
<digital-platform-trustarc-cm mode="banner"></digital-platform-trustarc-cm>
<digital-platform-feature-einstein-chatbot></digital-platform-feature-einstein-chatbot>
